var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3091_42570)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3091_42570",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V23H22V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3091_42570)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3091_42570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82166 0.205238L16.5834 0.197266L16.648 0.228329L21.1351 4.73313L21.2152 4.84434L21.2311 21.7736C21.2236 21.9171 21.104 22.0225 20.9698 22.0445C15.2049 22.0546 9.20656 22.0564 3.44156 22.0463C3.26276 22.0171 3.19516 21.8883 3.18066 21.7176V13.4924V13.3682L3.97576 12.6393L3.97966 12.874V21.1971H20.3978V5.25094L20.3692 5.22218H16.4081C16.3213 5.22218 16.1885 5.04635 16.1885 4.96341V1.0157H3.96636V8.79681L3.18066 9.45853V0.711539C3.19456 0.596576 3.38936 0.209661 3.82166 0.205238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6266 12.2676H16.3853V20.5476H17.6266V12.2676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0192 14.6621H9.77783V20.5462H11.0192V14.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3313 15.832H13.0815V20.5471H14.3313V15.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71542 17.6328H6.47412V20.5605H7.71542V17.6328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6705 11.2604C15.3249 11.6117 14.9758 11.9634 14.6303 12.3164C14.5917 12.386 14.6942 12.5403 14.7148 12.6288C15.0222 13.9439 13.1678 14.5171 12.6801 13.2909C12.5999 13.0893 12.5931 12.9003 12.6144 12.6868L11.162 11.9654C11.0592 12.0236 11.0039 12.11 10.898 12.1727C10.5535 12.3767 10.1355 12.3601 9.78686 12.1768C9.73366 12.1788 9.61886 12.3229 9.57736 12.3605C9.08216 12.8094 8.58696 13.2583 8.10556 13.7225L8.10016 13.747C8.28826 14.1284 8.23756 14.5952 7.96286 14.9193C7.43686 15.5397 6.44066 15.3728 6.14826 14.614C5.77956 13.6573 6.84506 12.7705 7.70556 13.3156L9.36726 11.7663C9.39026 11.7159 9.29256 11.4823 9.28326 11.3908C9.13136 9.88543 11.3352 9.77642 11.4196 11.1826C11.4241 11.2568 11.3876 11.4341 11.4198 11.4701L12.833 12.1616C12.8542 12.1732 12.8685 12.1693 12.8893 12.1602C12.9574 12.1303 13.0787 11.9944 13.1722 11.9444C13.3715 11.8378 13.59 11.8032 13.8143 11.8269C13.9553 11.8417 14.0765 11.916 14.2134 11.9368L16.0329 10.0799C16.0066 9.97603 15.947 9.88619 15.9204 9.77067C15.721 8.908 16.5906 8.19067 17.4042 8.54981C18.1255 8.86821 18.2513 9.83653 17.6546 10.3482C17.309 10.6446 16.8424 10.6692 16.4421 10.4727L15.6705 11.2604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48886 9.76639C5.53406 9.81826 5.70996 9.9799 5.71026 10.0335L3.61976 12.1903C3.12936 12.5897 2.67766 13.2561 2.18626 13.6265C1.44476 14.1854 0.342763 13.949 0.439563 12.8701C0.486163 12.3505 0.867463 12.0531 1.23226 11.7491C2.29176 10.8664 3.41076 9.97099 4.49786 9.12318C4.54626 9.08541 4.72826 8.92894 4.77436 8.95885C5.01026 9.22998 5.25256 9.49574 5.48886 9.76639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9369 8.01367C6.1589 8.37799 6.4641 8.6774 6.7793 8.95975L6.102 9.64131L5.1748 8.6148C5.1748 8.5752 5.4048 8.39601 5.4528 8.35642C5.5922 8.24128 5.7454 8.13946 5.8826 8.02105L5.9369 8.01367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3488 5.59352C13.3488 7.70868 11.6404 9.42337 9.5328 9.42337C7.4252 9.42337 5.7168 7.70868 5.7168 5.59352C5.7168 3.47837 7.4252 1.76367 9.5328 1.76367C11.6404 1.76367 13.3488 3.47837 13.3488 5.59352ZM12.742 5.59295C12.742 3.81373 11.3049 2.37141 9.5321 2.37141C7.7594 2.37141 6.3223 3.81373 6.3223 5.59295C6.3223 7.37216 7.7593 8.81448 9.5321 8.81448C11.3049 8.81448 12.742 7.37216 12.742 5.59295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5545 5.07421C10.403 5.22637 10.126 5.15782 10.0734 4.94709C10.0445 4.83146 10.0793 4.77873 9.9964 4.66023C9.7814 4.35296 9.1847 4.37242 9.032 4.72495C8.9098 5.0071 9.1626 5.10921 9.3701 5.21218C9.9335 5.49174 10.7788 5.6694 10.6131 6.5034C10.5346 6.8982 10.2008 7.18276 9.8246 7.28371C9.7903 7.52704 9.9248 8.07543 9.5209 8.05233C9.1422 8.03066 9.2703 7.53461 9.2346 7.28409C8.9444 7.19723 8.6626 7.00692 8.5294 6.72697C8.4288 6.51567 8.3475 6.14541 8.6268 6.04321C8.7157 6.01061 8.7505 6.01502 8.8361 6.055C9.0384 6.14934 8.9638 6.31865 9.0427 6.4801C9.2221 6.84749 9.9017 6.83138 10.0415 6.44702C10.1051 6.27215 10.0429 6.17455 9.8992 6.0805C9.4585 5.79211 8.5214 5.65061 8.4435 5.01151C8.3774 4.46954 8.7304 4.03514 9.241 3.90907C9.2514 3.63084 9.15 3.05311 9.6115 3.14937C9.9222 3.21418 9.7802 3.67494 9.8256 3.89277C10.055 3.98337 10.2702 4.08778 10.427 4.28585C10.5699 4.46619 10.7436 4.88457 10.5545 5.07421Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3091_42570",
    x: -29.7482,
    y: 0.197266,
    width: 81.161,
    height: 82.2191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30.1818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.0909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3091_42570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3091_42570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3091_42570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostInsights);
export default __webpack_public_path__ + "static/media/CostInsights.b2fcafade53f9dbf2ebd7ade9c8cd384.svg";
export { ForwardRef as ReactComponent };